import { Aereo } from './aereo.model';
import { BetoCarrero } from './beto-carrero.model';
import { Quarto } from './busca.model';
import { Carro } from './carro.model';
import { Circuito } from './circuito.model';
import { Hotel } from './hotel.model';
import { Pacote, PacoteReserva } from './pacote.model';
import { Servico } from './servico.model';

export class Orcamento {
  Id = 0;
  public Aereos: Aereo[] = [];
  public Hoteis: Hotel[] = [];
  public Servicos: Servico[] = [];
  public ServicosExclusivos: Servico[] = [];
  public Pacotes: Pacote[] = [];
  public PacoteReservas: PacoteReserva[] = [];
  static Servicos: any;
  public Carros: Carro[] = [];
  public BetoCarreroIngressos: BetoCarrero[] = [];
  public Circuitos: Circuito[] = [];
  public quartos: Quarto[] = [];
  public AgenciaId: number;
}
